<template>
    <v-dialog
        v-model="touched"
        max-width="480"
    >
        <template #activator="{ on, attrs }">
            <slot v-bind="{ on, attrs }"></slot>
        </template>

        <v-card>
            <v-card-title class="customized-primary white--text">
                ID: {{ value.id }} / {{ t('workout_label_id') }}: {{ value.workoutId }}
            </v-card-title>

            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <v-text-field
                        v-model="value.totalDistance"
                        type="text"
                        :label="t('workouts_label_distance')"
                        required
                        outlined
                        dense
                        :error-messages="form.errors.get('distance')"
                    ></v-text-field>
                    <v-text-field
                        v-model="value.totalDuration"
                        type="text"
                        :label="t('workouts_label_duration')"
                        required
                        outlined
                        dense
                        :error-messages="form.errors.get('duration')"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    color="primary"
                    @click="submit"
                    width="45%"
                    dark
                >{{ t('general_action_update') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="orange"
                    @click="touched = false"
                    width="45%"
                    dark
                >{{ t('general_action_cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {defineComponent, onMounted, reactive, toRefs, watch} from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useForm } from '@/core/form'
    import { WorkoutExecution } from '@/core/models/workout-execution'

    export default defineComponent({
        name: 'WorkoutExecutionDataModal',
        computed: {
            props() {
                return props
            }
        },

        /**
         * Component props.
         */
        props: {
            value: {
                type: WorkoutExecution
            }
        },

        /**
         * Component constructor.
         * @param props
         * @param context
         */
        setup(props, context) {
            const store = useStore()

            const state = reactive({
                touched: false
            })

            const i18n = useI18n()
            const form = reactive(useForm())

            const submit = () => {
                form.usingSubmit(store.dispatch('workoutExecution/putData', { id: props.value.id, payload: { distance: props.value.totalDistance, duration: props.value.totalDuration } }))
                    .then(() => {
                        state.touched = false
                        store.dispatch('notify', { color: 'success', message: i18n.t('general_notice_data_updated') })
                        context.emit('touched')
                    })
            }

            watch(() => [
                state.touched,
            ], () => {
                form.clear()
            })

            return {
                form,
                submit,
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>
